import {useCallback} from 'react';

import {FileUploadItem} from './FileUploadItem';

import type {UploadedFile} from './file-upload.types';

export interface UploadedDocumentListProps {
  documents: UploadedFile[];
  isLoading: boolean;
  onDelete?: (fileId: string) => Promise<void>;
  onDownload?: (fileId: string) => Promise<string>;
  onView?: (fileId: string) => Promise<void>;
  deleteLabel?: string;
  downloadLabel?: string;
  viewLabel?: string;
}

export function UploadedDocumentList({
  documents,
  isLoading,
  onDelete,
  onDownload,
  onView,
  deleteLabel,
  downloadLabel,
  viewLabel
}: UploadedDocumentListProps) {
  const handleDownload = useCallback(
    async (fileId: string) => {
      if (onDownload) {
        const url = await onDownload(fileId);
        const a = document.createElement('a');
        a.href = url;
        a.download = '';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    [onDownload]
  );

  const handleView = useCallback(
    async (fileId: string) => {
      await onView?.(fileId);
    },
    [onView]
  );

  if (documents.length === 0) return null;

  return (
    <div className="flex flex-col gap-2">
      {documents.map(doc => (
        <FileUploadItem
          key={doc.id}
          fileName={doc.fileName}
          fileSize={doc.fileSize}
          uploadedAt={doc.uploadedAt}
          onRemove={onDelete ? () => onDelete(doc.id) : undefined}
          onDownload={onDownload ? () => handleDownload(doc.id) : undefined}
          onView={onView ? () => handleView(doc.id) : undefined}
          isLoading={isLoading}
          deleteLabel={deleteLabel}
          downloadLabel={downloadLabel}
          viewLabel={viewLabel}
        />
      ))}
    </div>
  );
}
